<template>
  <div class="tab">
    <div class="items" v-for="(item, i) in Items" :key="item.name">
      <ProdItem
        :name="item.name"
        :index="i"
        :level="item.level"
        :price="item.price"
        :time="item.time"
        :icon="item.icon"
        :on="item.enabled"
      />
    </div>
  </div>
</template>

<script>
import ProdItem from "@/components/ProdItem.vue";

export default {
  name: "Tab Production",
  components: { ProdItem },
  props: {},

  computed: {
    Items: function() {
      return this.$store.state.prodItems;
    },
  },

  mounted: function() {},

  methods: {
    click: function() {},
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.navBar {
  width: 100%;
  position: fixed;
  bottom: 0;
  display: flex;
  background: #fff;
  border-top: 4px solid $gray300;
  justify-content: space-around;
  div {
    margin: 12px 0;
    img {
      margin-bottom: 4px;
    }
  }
}
</style>
